import Vue from 'vue'
import {fetchUserByEmail, login, refreshToken} from '@/api/user.api'
import router from '../../router'

const state = {
    jwt: '',
    refreshToken: '',
    loggedInUser: {},
    authenticated: false,
    loggingIn: false
}

const getters = {
    getJWT: state => state.jwt,

    getRefreshToken: state => state.refreshToken,

    getLoggedInUser: state => state.loggedInUser,

    isAuthenticated: state => state.authenticated,

    isLoggingIn: state => state.loggingIn
}

const actions = {
    async adminLogin({commit, dispatch}, request) {
        await login(request)
            .then(response => {
                commit('setLoggingIn', true)
                commit('setJWT', response.headers['authorization'].split(' ')[1])
                commit('setRefreshToken', response.headers['refresh'].split(' ')[1])
                dispatch('fetchUser', request.email)
            })
            .catch(() => {
                Vue.notify({
                    group: 'errors',
                    title: 'Greška u prijavi',
                    text: 'Neispravni email ili sifra!'
                })
            })
    },

    async fetchUser({commit}, email) {
        await fetchUserByEmail(email)
            .then(response => {
                commit('setLoggedInUser', response.data)
                commit('setLoggingIn', false)
                router.push({ name: 'adminOrders' })
            })
            .catch(() => {
                Vue.notify({
                    group: 'errors',
                    title: 'Greška na serveru',
                    text: 'Doslo je do greške na serveru, molimo Vas pokušajte kasnije'
                })
            })
    },

    async refreshToken({state, commit}) {
        const credentialsJson = require('/credentials.json')

        const refreshTokenDTO = {
            refreshToken: state.refreshToken,
            clientId: credentialsJson.clientId,
            clientSecret: credentialsJson.clientSecret
        }

        await refreshToken(refreshTokenDTO)
            .then(response => {
                commit('setJWT', response.data)
            })
    }
}

const mutations = {
    setJWT: (state, jwt) => state.jwt = jwt,

    setRefreshToken: (state, refreshToken) => state.refreshToken = refreshToken,

    setLoggedInUser: (state, user) => {
        state.loggedInUser = user
        state.authenticated = true
    },

    setLoggingIn: (state, loggingIn) => state.loggingIn = loggingIn,

    clearAuthenticationState: state => {
        state.jwt = ''
        state.refreshToken = ''
        state.loggedInUser = ''
        state.authenticated = false
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}